import { render, staticRenderFns } from "./ProcessArticle.vue?vue&type=template&id=97d4ee1c&scoped=true"
import script from "./ProcessArticle.vue?vue&type=script&lang=js"
export * from "./ProcessArticle.vue?vue&type=script&lang=js"
import style0 from "./ProcessArticle.vue?vue&type=style&index=0&id=97d4ee1c&prod&lang=css"
import style1 from "./ProcessArticle.vue?vue&type=style&index=1&id=97d4ee1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d4ee1c",
  null
  
)

export default component.exports